// Provenance of a per-model spend row's `costUsd`, as the /analytics table
// badges it.
//
// This reads the ledger's own `cost_source` rather than inferring provenance
// from "a reported figure exists". The two stopped meaning the same thing when
// coding rows became `repriced`: the `claude` CLI converts its token counts on
// a $3/$15 sonnet catalog while Anthropic bills Sonnet 5 and 5.5 at $2/$10, so
// `costUsd` is the CLI's figure moved onto the billed rate and
// `reportedCostUsd` is the untouched input the correction is reversible from.
// Under the old rule the badge claimed "reported" over a number no source ever
// reported.

import type { SpendCostSource } from "@loom/shared/spend";

/** Message key for a provenance value. One key per enum member, so a new
 *  member surfaces as a missing translation in tests rather than as a raw key
 *  in a table cell. */
export const modelSourceLabelKey = (
  source: SpendCostSource,
): `analytics.models.source.${SpendCostSource}` =>
  `analytics.models.source.${source}`;
